import { set } from 'cerebral/operators'
import { state } from 'cerebral/tags'

const trigger = ({ controller, state }) => {
  const confirm = state.get('app.dialog.confirm')
  // We have to use setTimeout to not trigger signal in signal
  if (confirm) {
    setTimeout(() => {
      controller.getSignal(confirm.signal)(confirm.args)
    }, 0)
  }
}

export default [trigger, set(state`app.dialog`, null)]



// WEBPACK FOOTER //
// ./src/modules/App/chains/onConfirm.js